import { startbeitragRegistrieren, type Kernaktion, type Startlage } from "../plattform/startansicht";
import { useEigeneMeldungenStand, useRevierSammlungStand, useZugewieseneSuchenStand } from "./lage";
import { useSuchbereiche } from "./Suchbereich";

/**
 * Kernaktionen des Kontexts Schuss auf der Startansicht (oberflaeche.md §3.1, §4.3, §4.4; design/README §10.2):
 *
 * - Schütze: während der Jagd „Schuss“ als Hauptaktion; danach „Liegeort“, solange eine eigene Erlegung ohne Liegeort
 *   liegt, sonst „Schuss“; vor Beginn ist „Stand erreicht“ die Hauptaktion (Kontext Lage), „Schuss“ steht dann direkt in
 *   der Navigation – ist der Stand erreicht und hat keine Zeile der Person eine andere Hauptaktion, wieder an ihrer
 *   Stelle in `main` (Rückfall; dieselbe Lage wie während der Jagd, kein Sprung beim Beginn).
 * - Ansteller: danach „Bergeliste“ als weiteres Ziel vor den Zielen der Rolle (§4.3 „Abholliste; Bergeliste“).
 * - Bergetrupp: „Bergeliste“ in jeder Phase.
 * - Jeder Hundeführer mit zugewiesener offener Suche: der Suchbereich in `main`.
 */
const RANG_SCHUETZE = 0;
const RANG_ANSTELLER = 1;
/** Zeile „Bergetrupp“ in oberflaeche.md §4.3 (nach Schütze … Leitung, Nachweisprüfer) */
const RANG_BERGETRUPP = 8;

function useSchussbeitrag(lage: Startlage) {
  const eigene = useEigeneMeldungenStand();
  const bergeliste = useRevierSammlungStand(lage.drueckjagdId, lage.revier, "bergeliste");
  const suchen = useZugewieseneSuchenStand(lage.drueckjagdId);
  const kernaktionen: Kernaktion[] = [];
  const pfad = (teil: string) => `/drueckjagd/${lage.drueckjagdId}/${teil}`;
  if (lage.rollen.includes("Schütze")) {
    const meine = new Set(eigene.daten.filter((m) => m["_drueckjagd"] === lage.drueckjagdId).map((m) => String(m["Schuss"])));
    const offeneErlegung = bergeliste.daten.some((b) => meine.has(String(b["Schuss"])) && b["Erlegungsstatus"] === "liegt");
    const liegeortVorn = lage.phase === "danach" && offeneErlegung;
    const vorBeginn = lage.phase === "vor Beginn";
    kernaktionen.push({ begriff: "Schuss", symbol: "schuss", pfad: pfad("schuss"), rang: RANG_SCHUETZE, haupt: !liegeortVorn, ...(vorBeginn ? { rueckfall: true } : {}) });
    if (offeneErlegung) kernaktionen.push({ begriff: "Liegeort", symbol: "liegeort", pfad: pfad("liegeort"), rang: RANG_SCHUETZE, haupt: liegeortVorn });
  }
  if (lage.rollen.includes("Ansteller") && lage.phase === "danach") {
    kernaktionen.push({ begriff: "Bergeliste", symbol: "bergung", pfad: pfad("bergeliste"), rang: RANG_ANSTELLER, haupt: false, weiteresZiel: true });
  }
  // Bergetrupp (oberflaeche.md §4.3): „Bergeliste“ in jeder Phase; als Listenziel klein in der Zeile der weiteren Ziele
  // (design/README §4.4, K92 1), ist es nicht die Hauptaktion, zählt es zu den weiteren Zielen
  if (lage.rollen.includes("Bergetrupp")) {
    kernaktionen.push({ begriff: "Bergeliste", symbol: "bergung", pfad: pfad("bergeliste"), rang: RANG_BERGETRUPP, haupt: true, weiteresZiel: true });
  }
  const { bereiche, dialog } = useSuchbereiche(suchen.daten.filter((s) => s["Schuss"]));
  const bereit = !eigene.laedt && !bergeliste.laedt && !suchen.laedt;
  return { kernaktionen, bereit, bereiche: bereiche ?? undefined, ...(dialog ? { dialog } : {}) };
}

startbeitragRegistrieren(useSchussbeitrag);
